// extracted by mini-css-extract-plugin
export default {"button":"styles_button__EaERc","white":"styles_white__I-Y8H","delete":"styles_delete__rQjD6","bordered":"styles_bordered__Pwdc9","loaderWrap":"styles_loaderWrap__XWLOU"};